import { Component } from '@angular/core';
import { faQrcode } from '@fortawesome/free-solid-svg-icons'; 
import { ActivatedRoute, Router } from '@angular/router';
import { GameService } from '../../services/game.service';
import { State } from '../../interfaces/state.interface';

@Component({
  selector: 'app-nav-menu',
  templateUrl: './nav-menu.component.html',
  styleUrls: ['./nav-menu.component.scss']
})
export class NavMenuComponent {
  get faQrcode() { return faQrcode };

  private currentURL: string;
  isInGame: boolean = false;
  showQr: boolean = false;
  showQrMeme: boolean = false;
  constructor(private route: ActivatedRoute, private router: Router, private gameService: GameService) {
    this.gameService.stateUpdateReceived$.subscribe((state: State) => {
      this.currentURL = this.gameService.baseUrl + this.router.url.substr(1);
      this.isInGame = this.gameService.isConnected();
    });
    this.gameService.onDestroy$.subscribe(() => {
      this.isInGame = this.gameService.isConnected();
    })
  }


  showQrCode() {
    this.showQr = !this.showQr;
    this.showFunnyQr();
  }

  showFunnyQr() {
    this.showQrMeme = Math.floor(Math.random() * 6) == 1;
  }

}
